import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const systemApi = createAggrApiInstance(aggr.CommonSystemApi)

export const getPreComputedDataTime = async () => {
  const res = await handleApiStatus(() => systemApi.systemPrecomputeddatatimestamp())
  return res
}

export const clearPortalAllCache = async () => {
  const res = await handleApiStatus(() => systemApi.systemClearportalallcache())
  return res
}

export const clearWenkIndexAllCache = async () => {
  const res = await handleApiStatus(() => systemApi.systemClearwenkindexallcache())
  return res
}

export const refreshAllPreStatsClicks = async () => {
  const res = await handleApiStatus(() => systemApi.systemRefreshallprestatsclicks())
  return res
}

export const updateGaTodayData = async () => {
  const res = await handleApiStatus(() => systemApi.systemUpdategatodaydata())
  return res
}

export const refreshSubtagMa14Stats = async () => {
  const res = await handleApiStatus(() => systemApi.systemRefreshsubtagma14stats())
  return res
}

export const refreshBigQueryProjectSchedules = async () => {
  const res = await handleApiStatus(() => systemApi.systemRefreshbigqueryprojectschedules())
  return res
}

export const refreshShortUrlConversions = async () => {
  const res = await handleApiStatus(() => systemApi.systemRefreshshorturlconversions())
  return res
}

export const refreshOrgSubtagConversions = async () => {
  const res = await handleApiStatus(() => systemApi.systemRefreshorgsubtagconversion())
  return res
}

export const getApplicationVersion = async () => {
  const res = await handleApiStatus(() => systemApi.systemGetapplicationversion())
  return res
}

export const getSystemDataUpdatedTime = async () => {
  const res = await handleApiStatus(() => systemApi.systemGetsystemdataupdatetime())
  return res
}

export const getUrlGroupedByDate = async (startDate: string, endDate: string, includeDeleted?: boolean) => {
  const res = await handleApiStatus(() => systemApi.systemCounturlsgroupedbydate(startDate, endDate, includeDeleted))
  return res
}
